
import { Check, Zap, Crown, Shield } from 'lucide-react';
import './PricingPlans.css';

const PricingPlans = () => {
  const plans = [
    {
      icon: <Shield size={32} />,
      name: "Essential",
      price: "2,500",
      period: "per case",
      description: "Basic Investigation",
      features: [
        "Basic background checks",
        "Public records search",
        "Social media analysis",
        "Written report delivery",
        "5 business days turnaround",
        "Email support"
      ],
      color: "cyan",
      popular: false
    },
    {
      icon: <Zap size={32} />,
      name: "Professional",
      price: "7,500",
      period: "per case",
      description: "Comprehensive Investigation	",
      features: [
        "Everything in Essential",
        "Field surveillance operations",
        "Digital forensics analysis",
        "Asset location services",
        "Expert witness testimony",
        "Priority 48hr turnaround",
        "24/7 phone support",
        "Monthly retainer available"
      ],
      color: "emerald",
      popular: true
    },
    {
      icon: <Crown size={32} />,
      name: "Enterprise",
      price: "Custom",
      period: "tailored solution",
      description: "Custom – Tailored Solutions",
      features: [
        "Everything in Professional",
        "Dedicated investigation team",
        "International operations",
        "Cyber security assessment",
        "Crisis management support",
        "Real-time reporting dashboard",
        "On-site consultations",
        "Custom contract terms"
      ],
      color: "purple",
      popular: false
    }
  ];

  return (
    <section className="pricing-section">
      <div className="pricing-background">
        <div className="pricing-orb pricing-orb-1"></div>
        <div className="pricing-orb pricing-orb-2"></div>
        <div className="pricing-orb pricing-orb-3"></div>
      </div>

      <div className="section-container">
        <div className="section-header">
          <div className="section-badge">Transparent Pricing</div>
          <h2 className="section-title">Investigation Packages</h2>
          <p className="section-subtitle">
            Choose the service level that matches your needs. All packages include complete confidentiality.
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.color} ${plan.popular ? 'popular' : ''}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {plan.popular && (
                <div className="popular-badge">
                  <Zap size={16} />
                  <span>Most Popular</span>
                </div>
              )}

              <div className="pricing-header">
                <div className={`pricing-icon ${plan.color}`}>
                  {plan.icon}
                </div>
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>
              </div>

              <div className="pricing-price">
                <span className="currency">$</span>
                <span className="amount">{plan.price}</span>
                <span className="period">/{plan.period}</span>
              </div>

              <ul className="features-list">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="feature-item">
                    <Check size={20} className="check-icon" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`pricing-btn ${plan.color}`}>
                {plan.price === "Custom" ? "Contact Sales" : "Get Started"}
              </button>
            </div>
          ))}
        </div>

        <div className="pricing-note">
          <p>All prices are starting rates. Final costs depend on case complexity and duration. Free initial consultation included.</p>
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;
